<template>
  <a href="" class="product__btn product__btn--add" @click.prevent="addToCart(item.id, quantity)" v-model="id">
    <img v-if="detail != true"src="/static/img/pictos/panierssrond.svg" class="">
    <span v-if="detail == true">Ajouter au panier</span>
    <img v-if="detail == true" src="/static/img/pictos/panier.svg" alt="">
    </a>
  </a>
</template>

<script>


export default {
  name: "ProductAddToCart",
  props: [
    "item",
    "detail",
    "quantity",
    "modal"
  ],
  data() {
    return {
      id: "",
    }
  },
  created() {

  },
  computed: {

  },
  methods:{
    addToCart(id, quantity = 1){
      let idOrder = this.$store.getters['order/getCartOrderId'];
      const self = this
      this.$store.dispatch('showCartLoader');
      if(idOrder != null){
        this.$http.post('orderline', {
          order: { id : idOrder},
          product: {id : id},
          quantity: quantity,
        }).then(response => {
          //this.$store.dispatch('order/incrementNbItems');
        })
      }else{
        this.$http.post('order', {
          status: -1,
        }).then(response => {
          this.$emit("close")

          this.$http.post('orderline', {
            order: { id : response.data.object.id},
            product: {id : id},
            quantity: quantity,
          }).then(response => {
            this.$toastr.success(this.$i18n.t("success.cart.added"));
            this.$store.dispatch('order/incrementNbItems');
            this.$store.dispatch("order/getMyCart").then(function(){
              self.$store.dispatch('hideCartLoader');
            });
          }).catch(error => {
            this.$store.dispatch("order/getMyCart").then(function(){
              self.$store.dispatch('hideCartLoader');
            });
          })
        })
      }
    }
  },
  mounted() {

  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .product__btn{ width: 80px; text-align: center; height: 40px; color: white; line-height: 36px;
    img{ width: 20px; }
    &--add{ background-color: $color3; }
  }
  .product-detail__btn{ width: auto; text-align: center; height: 70px; color: white; padding: 0 30px; background-color: $color3; display: flex; align-items: center; line-height: auto;
    img{ width: 40px; }
    span{ font-family: 'ClanProBold'; font-size: 14px; margin-right: 20px; text-align: left; }
    &:hover{ text-decoration: none; }
  }
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductAddToCart.vue